export default __webpack_public_path__ + "static/media/AnimalsOrange_05.5d534e29.png";